import type { Map as MapType } from "maplibre-gl";
import type { MapUpdater, UpdaterContext } from "./types";
import { AircraftUpdater } from "./AircraftUpdater";
import { SilosUpdater } from "./SilosUpdater";
import { PdarsUpdater } from "./PdarsUpdater";
import { PrimitivesUpdater } from "./PrimitivesUpdater";
import { HeatmapUpdater } from "./HeatmapUpdater";
import { PdarProbabilityFieldUpdater } from "./PdarProbabilityFieldUpdater";
export class UpdaterRegistry {
  private updaters = new Map<string, MapUpdater>();
  private topicMap = new Map<string, MapUpdater[]>();
  private context: UpdaterContext | null = null;
  constructor(private map: MapType) {
    this.context = {
      map: this.map,
      getSource: (id) => this.map.getSource(id),
      hasImage: (id) => this.map.hasImage(id),
      addImage: (id, data) => this.map.addImage(id, data),
    };
  }
  async initialise() {
    const updaters: MapUpdater[] = [
      new AircraftUpdater(this.context!),
      new SilosUpdater(this.context!),
      new PdarsUpdater(this.context!),
      new PrimitivesUpdater(this.context!),
      new HeatmapUpdater(this.context!),
      new PdarProbabilityFieldUpdater(this.context!),
    ];
    for (const updater of updaters) {
      await updater.initialise(this.map);
      this.updaters.set(updater.name, updater);
      for (const topic of updater.topics) {
        if (!this.topicMap.has(topic)) {
          this.topicMap.set(topic, []);
        }
        this.topicMap.get(topic)!.push(updater);
      }
    }
  }
  async handleMessage(topic: string, payload: unknown) {
    const updaters = this.topicMap.get(topic);
    if (!updaters || updaters.length === 0) {
      console.warn(`[UpdaterRegistry] No updater for topic: ${topic}`);
      return;
    }
    // Route message to all updaters subscribed to this topic
    await Promise.all(
      updaters.map((updater) => updater.handleMessage(topic, payload)),
    );
  }
  getUpdater<T extends MapUpdater>(name: string): T | undefined {
    return this.updaters.get(name) as T | undefined;
  }
  destroy() {
    this.updaters.forEach((updater) => updater.destroy());
    this.updaters.clear();
    this.topicMap.clear();
  }
}
